import React from "react"
import PropTypes from "prop-types"

import { connect } from "react-redux"
import { AbstractEnumSelectObjectOptions } from "selects/containers/EnumSelect"
import { columnEnumFieldConnection } from "sheets/column-search-selectors"
import { searchByEnum } from "sheets/helper-functions"

// wrapper functional component the takes an enum field on a model and returns
// a select to filter a column
const ColumnEnumFieldSelect = ({
    value,
    search,
    filteredOptions,
    field,
    overrideLabel,
}) => (
    <AbstractEnumSelectObjectOptions
        dataCy="column-enum-select"
        multi
        value={value}
        label={overrideLabel}
        filteredOptions={filteredOptions}
        field={field}
        onChange={item => search(searchByEnum(item))}
    />
)

ColumnEnumFieldSelect.propTypes = {
    overrideLabel: PropTypes.string,
    filteredOptions: PropTypes.array,
    search: PropTypes.func.isRequired,
}

ColumnEnumFieldSelect.defaultProps = {
    filteredOptions: []
}

export default connect((state, props) => columnEnumFieldConnection(state, props))(ColumnEnumFieldSelect)
